module.exports = __webpack_public_path__ + "ecomondo_news-foto-1.jpg?c6b3e6ee5d5408bdf4b238e330c51683";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ecomondo_news-foto-1.jpg
// module id = 180
// module chunks = 0